import { colourString, HelpIcon, IconButton } from '@keplerco/core';
import React, { PropsWithChildren } from 'react';
import SkillLevelHelp from '../../../components/general/skill-level-help/skill-level-help';

export const WidgetCard = React.forwardRef<HTMLDivElement, PropsWithChildren<{ title: string; subtitle?: string; showSkillLevelHelp?: boolean; button?: React.ReactElement; onHelpClick?: () => void } & React.HTMLAttributes<HTMLDivElement>>>(
  ({ title, subtitle, showSkillLevelHelp, button, style, children, onHelpClick, ...props }, outerRef) => {
    const innerRef = React.useRef<HTMLInputElement>(null);
    React.useImperativeHandle(outerRef, () => innerRef.current!, []);

    return (
      <div {...props} ref={innerRef} className="card" style={{ display: 'flex', flexDirection: 'column', gap: 12, ...style }}>
        <div style={{ display: 'grid', gridTemplateColumns: !!button ? '1fr auto' : '1fr', alignItems: 'center', gap: 12 }}>
          <div>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
              <h3 style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                {title}
                {onHelpClick && (
                  <IconButton iconType="fill" onClick={onHelpClick}>
                    <HelpIcon />
                  </IconButton>
                )}
              </h3>
              {showSkillLevelHelp && <SkillLevelHelp />}
            </div>
            {!!subtitle && <p style={{ color: colourString('text_1') }}>{subtitle}</p>}
          </div>
          {button}
        </div>
        {children}
      </div>
    );
  }
);

WidgetCard.displayName = 'WidgetCard';
